import React from "react"
import { Copyright } from "./Style"

export default function FooterDesktop() {
  return <Copyright>&copy; Copyright Epiroc Sweden AB</Copyright>
}
